import Actions from '@/components/Menu/Actions';
import type { MenuAction } from '@/components/Menu/Actions';

type AppContextMenuItemsProps = {
  children?: React.ReactNode;
  header?: React.ReactNode;
  items?: MenuAction[];
  onCloseActions: (e?: React.MouseEvent<HTMLElement>) => void;
};

export function AppContextMenuItems({ children, header, items, onCloseActions }: AppContextMenuItemsProps) {
  return (
    <>
      {header}
      {items ? <Actions items={items} onClose={onCloseActions} /> : children}
    </>
  );
}
